<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-26 18:15:08
 * @LastEditTime: 2021-01-20 11:38:40
 * @LastEditors: daikeyi
 -->
<template>
<div id='page_Container'>
    <div class="page">
        <div id='main-container' class="main-container">
            <div class='details'>
                <div class='refundType'>
                    <p class='pStatusStr'>{{refundSuccessData.statusStr}}</p>
                    <p>{{refundSuccessData.createTime}}</p>
                </div>
                <div class='refundAmount'>
                    <p>
                        <span class='pull-left'>退款总金额</span>
                        <span v-if="refundSuccessData.memberOrderRefundItemList" class='spanAmount'>¥{{ESVBase.numberTofixed(refundSuccessData.refundTotalAmount)}}</span>
                        <span v-else class='spanAmount'>¥{{ESVBase.numberTofixed(refundSuccessData.amount)}}</span>
                    </p>
                </div>
                <div class='refundMessage'>
                    <h5>退款信息</h5>
                    <template v-for='item in refundSuccessData.memberOrderRefundItemList'>
                        <van-card v-if="refundSuccessData.memberOrderRefundItemList"  :key='item.id' :title="item.productName" :thumb="item.productImg">
                            <template slot='desc'>
                                <p class='descP'>{{item.specificationValue}}</p>
                                <p class='numP'>
                                    <span class='span1'>￥{{ESVBase.numberTofixed(item.amount)}}</span>
                                    <span class='span2'>x{{item.quantity}}</span>
                                </p>
                            </template>
                        </van-card>
                    </template>
                    <van-card v-if='!refundSuccessData.memberOrderRefundItemList' :title="refundSuccessData.productName" :thumb="refundSuccessData.productImg">
                        <template slot='desc'>
                            <p class='descP'>{{refundSuccessData.specificationValue}}</p>
                            <p class='numP'>
                                <span class='span2'>x{{refundSuccessData.quantity}}</span>
                            </p>
                        </template>
                    </van-card>
                    <div class='message'>
                        <p>退款原因：{{refundSuccessData.reason}}</p>
                        <p v-if="refundSuccessData.memberOrderRefundItemList">退款金额：¥{{ESVBase.numberTofixed(refundSuccessData.refundTotalAmount)}}</p>
                        <p v-else>退款金额：¥{{ESVBase.numberTofixed(refundSuccessData.amount)}}</p>
                        <p>申请时间：{{refundSuccessData.createTime}}</p>
                        <p>退款编号：{{refundSuccessData.refundCode}}</p>
                        <p v-if='refundSuccessData.type === "2" && refundSuccessData.status === "2" && !refundSuccessData.logisticsCompanyName'>物流信息：
                            <span @click='xLog(refundSuccessData)' class='txWl'>填写物流信息</span>
                        </p>
                        <p v-if='refundSuccessData.type === "2" && refundSuccessData.status === "2" && refundSuccessData.logisticsCompanyName'>
                            物流公司：{{refundSuccessData.logisticsCompanyName}}
                        </p>
                        <p v-if='refundSuccessData.type === "2" && refundSuccessData.status === "2" && refundSuccessData.logisticsCode'>
                            物流单号：{{refundSuccessData.logisticsCode}}
                        </p>
                    </div>
                </div>
                <div>
                    <van-row>
                        <van-col span="12" class='cloa cloaOne'>
                            <img :src="callImg" alt="">
                            <a :href='contactCustomer'>联系卖家</a>
                        </van-col>
                        <van-col span="12" class='cloa cloaTwo'>
                            <img :src="callPhoneImg" alt="">
                            <a :href='"tel:"+merchantPhone'>拨打电话</a>
                        </van-col>
                    </van-row>
                </div>
                <div class="back-btn">
                    <van-button size="large" type="primary" round @click="handleSubmit">返回</van-button>
                </div>
            </div>
        </div>
        <van-dialog v-model="show" show-cancel-button :before-close="beforeClose">
            <h5 class='title'>填写物流信息</h5>
            <van-field v-model="logCompany" label="" placeholder="请输入物流公司" />
            <van-field v-model="logCode" label="" type='number' placeholder="请输入物流单号" />
        </van-dialog>
    </div>
</div>
</template>

<script>
import {
    Toast
} from 'vant';
import {
    toastLoading,
    clearToastLoading
} from '@/utils/base/utils';

export default {
    components: {
        Toast
    },
    data() {
        return {
            headerImg: require('../assets/img/myCenter/defaultImg.png'),
            callImg: require('../assets/img/myCenter/call.png'),
            callPhoneImg: require('../assets/img/myCenter/callPhone.png'),
            refundSuccessData: {},
            show: false,
            logCompany: '',
            logCode: '',
            logObj: {},
            merchantPhone: '',
            contactCustomer: '',
            status: ''
        };
    },
    esvReady() {
        const ths = this;
        document.title = '退款详情';
        this.getMerchantInfo();
        let channelType = 'WECHAT';
        this.ESVStorage.getSessionValue('channelType', (data) => {
            channelType = data || '';
        });
        if (channelType.indexOf('APP') < 0) {
            this.contactCustomerLink();
        }

        this.ESVStorage.getSavedValue('refundSuccessData', (data) => {
            ths.refundSuccessData = data;
        });
        this.ESVStorage.getSavedValue('status', (data) => {
            ths.status = data;
            console.log(data);
        });
        window.addEventListener('popstate', function (e) {
            if (
                e.target.location.hash === '#/refund?type=1' ||
                e.target.location.hash === '#/refund?type=2'
            ) {
                ths.esvOpenPage('OPMyOrder');
            } else {}
        });
    },
    methods: {
        xLog(item) {
            this.show = true;
            this.logObj = item;
        },
        fillRefundLogistics(item) {
            const ths = this;
            const params = {
                refundCode: item.refundCode,
                logisticsCompanyName: ths.logCompany,
                logisticsCode: ths.logCode
            };
            ths.$doRequest({
                url: '/order/fillRefundLogistics',
                params: params,
                before: function () {
                    ths.loading = toastLoading();
                },
                complete: function () {
                    clearToastLoading(ths.loading);
                }
            },
            function (data) {
                ths.show = false;
                ths.openGoodDetails(item);
            }
            );
        },
        // 查询链接
        contactCustomerLink() {
            const ths = this;
            ths.$doRequest({
                url: '/merchant/contactCustomer',
                params: {

                },
                before: function () {
                    ths.loading = toastLoading();
                },
                complete: function () {
                    clearToastLoading(ths.loading);
                }
            },
            function (data) {
                ths.contactCustomer = data.result;
            }
            );
        },
        // 查询电话号码
        getMerchantInfo() {
            const ths = this;

            ths.$doRequest({
                url: '/merchant/getMerchantInfo',
                params: {

                }
            },
            function (data) {
                ths.merchantPhone = data.result.merchantPhone;
            }
            );
        },
        // 查看详情
        openGoodDetails(item) {
            const ths = this;
            const params = {
                refundItemId: item.id
            };
            ths.$doRequest({
                url: '/order/queryMemberRefundItem',
                params: params,
                before: function () {
                    ths.loading = toastLoading();
                },
                complete: function () {
                    clearToastLoading(ths.loading);
                }
            },
            function (data) {
                ths.refundSuccessData = data.result;
            }
            );
        },
        beforeClose(action, done) {
            if (action === 'confirm') {
                if (this.logCompany.length <= 0) {
                    Toast('请输入物流公司');
                    done(false);
                    return false;
                }
                if (this.logCode.length <= 0) {
                    Toast('请输入物流单号');
                    done(false);
                    return false;
                }
                this.fillRefundLogistics(this.logObj);
            } else {
                done();
            }
        },
        handleSubmit() {
            if (this.status === '4' || this.status === '5') {
                this.esvBackPage(3);
            } else if (this.status === '9') {
                this.esvBackPage(1);
            } else {
                this.esvBackPage(2);
            }
        }
    },
    esvBack(backFn) {
        backFn && backFn(false);
    }
};
</script>

<style lang="scss" scoped>
.title {
    font-weight: 500;
    text-align: center;
    padding: 10px 0;
    font-size: 16px;
}

.details {
    .refundType {
        background: #ee2e50;
        padding: 10px 12px;

        .pStatusStr {
            font-size: 18px;
            padding-bottom: 3px;
        }

        p {
            text-align: center;

            color: #fff;
        }
    }

    .refundAmount {
        background: #fff;
        padding: 12px;

        .spanAmount {
            float: right;
            color: #ee2e50;
        }

        p {
            overflow: hidden;

            span {
                font-size: 14px;
            }
        }
    }

    .refundMessage {
        margin-top: 12px;
        background: #fff;

        h5 {
            font-weight: 500;
            font-size: 14px;
            padding: 12px;
        }

        .message {
            padding: 12px;
            font-size: 12px;
            color: #999;
            border-bottom: 1px solid #f3f2f2;

            p {
                padding: 3px 0;
            }

            .txWl {
                padding: 2px 4px;
                border: 1px solid #ee2e50;
                color: #ee2e50;
            }
        }
    }

    .cloa {
        flex-direction: row;
        align-items: center;
        /*垂直居中*/
        justify-content: center;
        display: flex;
        background: #fff;

        img {
            width: 18.7px;
            margin-right: 5px;
        }

        height: 50px;
        line-height: 50px;
    }

    .cloaOne {
        text-align: center;
        border-right: 1px solid #f3f2f2;

        a {
            color: rgb(65, 65, 65);
        }
    }

    .cloaTwo {
        text-align: center;

        a {
            color: #414141;
        }
    }
}

.numP {
    overflow: hidden;

    .span1 {
        float: left
    }

    .span2 {
        float: right;
        color: #ee2e50;
    }
}
.back-btn {
    margin: 24px 24px 0;
}
</style>
